/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

/*slick dots like instagram js start here
$(document).ready(function() {  
 
  function setBoundries(slick, state) {
    if (state === 'default') {
      slick.find('ul.slick-dots li').eq(4).addClass('n-small-1');
    }
  }

  // Slick Selector.
  var slickSlider = $('.product-main-slider');
  var maxDots = 5;
  var transformXIntervalNext = -18;
  var transformXIntervalPrev = 18;

  slickSlider.on('init', function (event, slick) {
    $(this).find('ul.slick-dots').wrap("<div class='slick-dots-container'></div>");
    $(this).find('ul.slick-dots li').each(function (index) {
      $(this).addClass('dot-index-' + index);
    });
    $(this).find('ul.slick-dots').css('transform', 'translateX(0)');
    setBoundries($(this),'default');
  });

  var transformCount = 0;
  slickSlider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    var totalCount = $(this).find('.slick-dots li').length;
    if (totalCount > maxDots) {
      if (nextSlide > currentSlide) {
        if ($(this).find('ul.slick-dots li.dot-index-' + nextSlide).hasClass('n-small-1')) {
          if (!$(this).find('ul.slick-dots li:last-child').hasClass('n-small-1')) {
            transformCount = transformCount + transformXIntervalNext;
            $(this).find('ul.slick-dots li.dot-index-' + nextSlide).removeClass('n-small-1');
            var nextSlidePlusOne = nextSlide + 1;
            $(this).find('ul.slick-dots li.dot-index-' + nextSlidePlusOne).addClass('n-small-1');
            $(this).find('ul.slick-dots').css('transform', 'translateX(' + transformCount + 'px)');
            var pPointer = nextSlide - 3;
            var pPointerMinusOne = pPointer - 1;
            $(this).find('ul.slick-dots li').eq(pPointerMinusOne).removeClass('p-small-1');
            $(this).find('ul.slick-dots li').eq(pPointer).addClass('p-small-1');
          }
        }
      }
      else {
        if ($(this).find('ul.slick-dots li.dot-index-' + nextSlide).hasClass('p-small-1')) {
          if (!$(this).find('ul.slick-dots li:first-child').hasClass('p-small-1')) {
            transformCount = transformCount + transformXIntervalPrev;
            $(this).find('ul.slick-dots li.dot-index-' + nextSlide).removeClass('p-small-1');
            var nextSlidePlusOne = nextSlide - 1;
            $(this).find('ul.slick-dots li.dot-index-' + nextSlidePlusOne).addClass('p-small-1');
            $(this).find('ul.slick-dots').css('transform', 'translateX(' + transformCount + 'px)');
            var nPointer = currentSlide + 3;
            var nPointerMinusOne = nPointer - 1;
            $(this).find('ul.slick-dots li').eq(nPointer).removeClass('n-small-1');
            $(this).find('ul.slick-dots li').eq(nPointerMinusOne).addClass('n-small-1');
          }
        }
      }
    }
  });


});
/*slick dots like instagram js end here*/

$(document).ready(function(){
  $('.cm_ft_sections').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          fade: true,
          dots: true,
//           autoplay: true,
//           autoplaySpeed: 6000,
        }
      },
    ]
  });
   
  $('.logo_col').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          arrows: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true
        }
      } 
    ]
  });

  $('.cm_review_part').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          fade: true,
          dots: true,
          autoplay: true,
          autoplaySpeed: 6000,
        }
      },
    ]
  });
  $('.product-main-slider').on('init', function(event, slick) {
    // Mute all videos in the main slider
    $('.product-main-slider video').prop('muted', true);
  });

  
  $('.product-main-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    // adaptiveHeight: true,
    asNavFor: '.product-thumb-slider',    
    responsive: [
      {
        breakpoint: 1008,
        settings: {
          dots: true,
          adaptiveHeight: true
        }
      },
    ]
  });
  
  $('.product-thumb-slider').slick({
    slidesToScroll: 1,
    vertical:true,
    asNavFor: '.product-main-slider',
    dots: false,
    arrows: false,
    infinite: false,
    focusOnSelect: true,
    verticalSwiping:true
  });

  // Handle video play/pause on slide change
$('.product-main-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    var currentVideo = $('.product-main-slider .slick-slide[data-slick-index="' + currentSlide + '"]').find('video')[0];
    var nextVideo = $('.product-main-slider .slick-slide[data-slick-index="' + nextSlide + '"]').find('video')[0];
    
    if (currentVideo) {
      currentVideo.pause();
    }
    
    if (nextVideo) {
      nextVideo.play();
    }
  });

  $(document).on('ready',function(e){
    $checked_input_variant_value = $('.ProductForm__Variants .ColorSwatch__Radio:checked').data('optionValue');
    $checked_input_label_value = $('.ProductForm__Variants .ColorSwatch__Radio:checked').val();
    var shade_text = $('.ProductForm__Variants .ColorSwatch__Radio:checked').attr('data-shade-text');
    set_labels($checked_input_label_value,shade_text);
    filter_slick($checked_input_variant_value, true);
  });

  $(document).on('click','.ColorSwatchList .ColorSwatch__Radio',function(){
    $checked_input_variant_value = $(this).data('optionValue');
    $checked_input_label_value = $(this).val();
    var shade_text = $(this).attr('data-shade-text');
    set_labels($checked_input_label_value,shade_text);
    filter_slick($checked_input_variant_value);
  });

  $('.ColorSwatchList label.ColorSwatch').on('mouseover',function(){
    if($(window).width() >= 1008) {
      $checked_input_variant_value = $(this).parent().find('.ColorSwatch__Radio').data('optionValue');
      $checked_input_label_value = $(this).parent().find('.ColorSwatch__Radio').val();
      var shade_text = $(this).parent().find('.ColorSwatch__Radio').attr('data-shade-text');
      set_labels($checked_input_label_value,shade_text);
      filter_slick($checked_input_variant_value); 
    }
  });

  $( ".ColorSwatchList" ).mouseleave(function() {
    if($(window).width() >= 1008) {
      $('.ProductForm__SelectedValue').text('');
      $('.shade-text').text('');

      $checked_input_variant_value = $('.ProductForm__Variants .ColorSwatch__Radio:checked').data('optionValue');
      $checked_input_label_value = $('.ProductForm__Variants .ColorSwatch__Radio:checked').val();
      var shade_text = $('.ProductForm__Variants .ColorSwatch__Radio:checked').attr('data-shade-text');
      set_labels($checked_input_label_value,shade_text);
      filter_slick($checked_input_variant_value);
    }
  });

  function set_labels($variant_value,$shade_text) {
    $('.ProductForm__SelectedValue').text($variant_value);
    $('.shade-text').text($shade_text);
  }  

  function filter_slick($value,$show_after_filter = false) {

    if($('.product-main-slider').length && $('.product-thumb-slider').length && $('.product-main-slider').hasClass('slick-initialized') && $('.product-thumb-slider').hasClass('slick-initialized') && $('.ColorSwatchList').length) {
      
        if($value !== undefined) {
          $slick_filter_class = '.slick-' + $value;
        } else {
          $slick_filter_class = '.slick-default';
        }    

        $('.product-main-slider').slick('slickUnfilter');
        $('.product-thumb-slider').slick('slickUnfilter');

        $('.product-main-slider').slick('slickFilter', $slick_filter_class).slick('slickGoTo', 0).slick('refresh');
        $('.product-thumb-slider').slick('slickFilter', $slick_filter_class).slick('slickGoTo', 0).slick('refresh');

        if($show_after_filter) {
          $('.Product__Gallery').addClass('show-after-filter');
        }
      } else {
        if($show_after_filter) {
          $('.Product__Gallery').addClass('show-after-filter');
        }
      }
    }



  
  //////////// custom popup js ////////////

	jQuery("body").on('click', ".popup-opener", function(e){
	  e.preventDefault();
	  var $parents = jQuery(this).attr('data-popup-id');
	  var $customPop = jQuery(this).attr('data-overlay');
	  jQuery("div[data-popup='" + $parents + "']").addClass("active");
	  if($customPop !== "false"){jQuery('.overlay').addClass("active");}
	  jQuery("div[data-popup='" + $parents + "']").siblings(".cs-popup").removeClass("active");
	  jQuery(this).addClass("active");
	});

	jQuery("body").on('click', ".close-icon", function(e){
	  e.preventDefault();
	  var $parents = $('.active').attr('data-popup');
	  jQuery(this).closest(".cs-popup").removeClass("active");
	  jQuery('.overlay').removeClass("active");
	  jQuery('.popup-opener').removeClass("active");
	});

	jQuery("body").on('click', ".overlay", function(e){
	  e.preventDefault();
	  var $parents = $('.active').attr('data-popup');
	  jQuery('.cs-popup').removeClass('active');
	  jQuery('.overlay').removeClass("active");
	  jQuery('.popup-opener').removeClass("active");
	});

	jQuery(document).keyup(function(e) {
	  if (e.keyCode == 27) {
		jQuery(".cs-popup").removeClass("active");
		jQuery('.overlay').removeClass("active");
		jQuery('.popup-opener').removeClass("active");
	  }
    });  
  $(".yotpo.bottomLine").click(function(e) {
    e.preventDefault();
    if($("#find_reviews").length){
      $('html, body').animate({
        scrollTop: $("#find_reviews").offset().top
      }, 2000);
    }
  });
  
//   $('.Slideshow__Carousel').on( 'settle.flickity', function() {
//     newTarg = jQuery(".carousel-cell.flex-video").not('.is-selected');
//       $(newTarg).find('iframe').each(function() { 
//         var src= $(this).attr('src').split("?")[0];
//         $(this).attr('src', src+'?autoplay=0&controls=0&loop=1&showinfo=0&rel=0');
//       });
//   });
//    $('.Slideshow__Carousel').on( 'settle.flickity', function() {
//     newTargs = jQuery(".carousel-cell.flex-video.is-selected");
//       $(newTargs).find('iframe').each(function() { 
//         var src= $(this).attr('src').split("?")[0];
//         $(this).attr('src', src+'?autoplay=1&controls=0&loop=1&showinfo=0&rel=0');
//       });
//   });

  $('.product-grid-hp').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          fade: true,
          dots: true,
          arrows: true
        }
      },
    ]
  });
  $(".Product__Tabs .Collapsible__Button ").click(function() {
    var clc_ele = $(this);
    setTimeout(function(){
      $('html, body').animate({
        scrollTop: clc_ele.offset().top - $('#shopify-section-header').outerHeight()
      }, 500);
    },500);
  });
});


/* PRODUCT SETS JS */

$bundle_toggle = '.js-utility-nav-toggle';
$bundle_toggleText = '.js-utility-nav-toggle-text';
$bundle_toggleSwatch = '.js-utility-nav-toggle-swatch';
$bundle_dropdown = '.js-utility-nav-dropdown';
$swatch_selector = '.ProductBundleSwatchSelector';
$swatches = '.js-swatch-selection';
$underlay = '.UnderlayTransparent';
$navigation_item = '.ProductBundleSwatchSelector__navigation-item';
$formInput_selector = '.js-variant-input';
$formInputs = '.js-bundle-product-form .js-variant-input';
$bundleUniqueIdInputs = '.js-variant-input-property-bundle-unique';
$alternate_form_selector = '.js-bundle-product-form';
$form_selector = '.js-product-form';
$addtocart_btn = '.ProductForm__AddToCart';


$(document).on('ready',function(){
  setUniqueIds();
  checkForSelections();
});

$(document).on('click', $bundle_toggle, function(e){
  e.preventDefault();
  $(this).attr('aria-expanded', $(this).attr('aria-expanded')=='false' ? 'true' : 'false');
  $(this).parents($swatch_selector).toggleClass('is-expanded');
  $($underlay).toggleClass('UnderlayTransparent--active');
});

$(document).on('click', '.UnderlayTransparent', function(e){
  e.preventDefault();
  $($underlay).removeClass('UnderlayTransparent--active');
  $($swatch_selector).removeClass('is-expanded');
  $($bundle_toggle).attr('aria-expanded','false');
});

$(document).on('click', $swatches, function(e) {
  e.preventDefault();
  $data_swatch_style = $(this).data('swatchStyle');
  $data_color_name = $(this).data('colorName');
  $data_color_description = $(this).data('colorDescription');
  $data_variant_id = $(this).data('variantId');

  $(this).addClass('ProductSwatch__swatch--selected').parents($navigation_item).siblings().find($swatches).removeClass('ProductSwatch__swatch--selected');
  $(this).parents($swatch_selector).addClass('is-selected');
  $(this).parents($swatch_selector).find($bundle_toggleSwatch).attr('style',$data_swatch_style);
  $(this).parents($swatch_selector).find($bundle_toggleText).text($data_color_name);
  $(this).parents($swatch_selector).find($formInput_selector).val($data_variant_id);
  checkForSelections();

});
console.log("skskskskkksskskksskskskss", $addtocart_btn.length);


$(document).on('submit', '.js-bundle-product-form', function(e) {
  e.preventDefault()
  console.log("Clicked.....");
  addBundleToMiniCart();
});


function addBundleToMiniCart() {
//  e.preventDefault();

 var alternateForm = document.querySelector($alternate_form_selector);
 var mainForm = document.querySelector($form_selector);
 // var form = alternateForm || mainForm;
 // var formData = new FormData(form);
 var form = $(".js-bundle-product-form");

 document.dispatchEvent(new CustomEvent("theme:loading:start"));

 var $items_to_add_array = {};
 var $total_items = form.find(".ProductBundleSelectorItem").length - 1;

 form.find(".ProductBundleSelectorItem").each(function (iin, iiv) {
   var item_id_field =
     'input.ProductBundleSwatchSelector__input[name="items[' + iin + ']id"]';
   var bundle_handle_field =
     'input.ProductBundleSwatchSelector__input[name="items[' +
     iin +
     ']properties[_bundle_handle]"]';

   var bundle_discount_field =
     'input.ProductBundleSwatchSelector__input[name="items[' +
     iin +
     ']properties[_bundle_discount]"]';

   var bundle_price_field =
     'input.ProductBundleSwatchSelector__input[name="items[' +
     iin +
     ']properties[_bundle_price]"]';
   var bundle_unique_field =
     'input.ProductBundleSwatchSelector__input[name="items[' +
     iin +
     ']properties[_bundle_unique]"]';
   var item_unique_field =
     'input.ProductBundleSwatchSelector__input[name="items[' +
     iin +
     ']properties[_item_unique]"]';

   var $item_id = $(this).find(item_id_field).val();
   var $bundle_handle = $(this).find(bundle_handle_field).val();
   var $bundle_discount = $(this).find(bundle_discount_field).val();
   var $bundle_price = $(this).find(bundle_price_field).val();
   var $bundle_unique = $(this).find(bundle_unique_field).val();
   var $item_unique = $(this).find(item_unique_field).val();

   var $item_properties = {
     _bundle_handle: $bundle_handle,
     _bundle_discount: $bundle_discount,
     _bundle_price: $bundle_discount,
     _bundle_unique: $bundle_unique,
     _item_unique: $item_unique,
   };

   var $item = { id: $item_id, quantity: 1, properties: $item_properties };

   $items_to_add_array[iin] = $item;

   if (iin == $total_items) {
     $.ajax({
       type: "POST",
       url: "/cart/add.js",
       dataType: "json",
       data: {
         items: $items_to_add_array,
       },
       success: function () {
         document.dispatchEvent(new CustomEvent("theme:loading:end"));
         document.dispatchEvent(
           new CustomEvent("product:added", {
             detail: { quantity: $(".js-variant-input").length - 1 },
           })
         );
         setUniqueIds();
       },
     });
   }
 });
}
$(document).on('click', $addtocart_btn, function(e){
  e.preventDefault();

  var alternateForm = document.querySelector($alternate_form_selector);
  var mainForm = document.querySelector($form_selector);
  // var form = alternateForm || mainForm;
  // var formData = new FormData(form);
  var form = $('.js-bundle-product-form');

  document.dispatchEvent(new CustomEvent('theme:loading:start'));

  var $items_to_add_array = {};
  var $total_items = form.find(".ProductBundleSelectorItem").length - 1;

  form.find(".ProductBundleSelectorItem").each(function(iin,iiv){
    var item_id_field = 'input.ProductBundleSwatchSelector__input[name="items[' + iin + ']id"]';
    var bundle_handle_field = 'input.ProductBundleSwatchSelector__input[name="items[' + iin + ']properties[_bundle_handle]"]';
    
		var bundle_discount_field = 'input.ProductBundleSwatchSelector__input[name="items[' + iin + ']properties[_bundle_discount]"]';
		
    var bundle_price_field = 'input.ProductBundleSwatchSelector__input[name="items[' + iin + ']properties[_bundle_price]"]';
    var bundle_unique_field = 'input.ProductBundleSwatchSelector__input[name="items[' + iin + ']properties[_bundle_unique]"]';
    var item_unique_field = 'input.ProductBundleSwatchSelector__input[name="items[' + iin + ']properties[_item_unique]"]';

    var $item_id = $(this).find(item_id_field).val();
    var $bundle_handle = $(this).find(bundle_handle_field).val();
    var $bundle_discount = $(this).find(bundle_discount_field).val();
    var $bundle_price = $(this).find(bundle_price_field).val();
    var $bundle_unique = $(this).find(bundle_unique_field).val();
    var $item_unique = $(this).find(item_unique_field).val();

    var $item_properties = { 
			'_bundle_handle': $bundle_handle,
			'_bundle_discount': $bundle_discount,
			'_bundle_price': $bundle_discount,
			'_bundle_unique': $bundle_unique,
			'_item_unique': $item_unique};

    var $item = { 'id': $item_id, 'quantity': 1, 'properties': $item_properties };

    $items_to_add_array[iin] = $item;

    if(iin == $total_items) { 

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: {
          "items": $items_to_add_array
        },
        success: function() {
          document.dispatchEvent(new CustomEvent('theme:loading:end')); 
          document.dispatchEvent(new CustomEvent('product:added', { detail: { quantity: $('.js-variant-input').length - 1 } }));
          setUniqueIds();
        }
      });

    }
  });
  
  /* $.ajax({
    url: '/cart/add',
    method: 'post',
    data: formData,
    processData: false,
    contentType: false,
    cache: false,
    success: function() {
      document.dispatchEvent(new CustomEvent('theme:loading:end')); 
      document.dispatchEvent(new CustomEvent('product:added', { detail: { quantity: $('.js-variant-input').length - 1 } }));
      setUniqueIds();
    },
    error: function() { alert('some error occurred'); setUniqueIds(); }
  }); */
});

$(document).on('click','.Footer__Title',function(e){
  e.preventDefault();
  $(this).toggleClass('open');
  $(this).siblings('.Footer__Linklist').toggleClass('open');
});

function getselectedInputs() {
  var $valid = true;
  $($formInputs).each(function(){
    if($(this).val() == "") { $valid = false; }
  });

  return $valid;
}

function setUniqueIds() {
  const $millisecs = Date.now();

  $($bundleUniqueIdInputs).each(function(){
    var $initial_val = $(this).data('initialValue');
    $(this).val($initial_val + '__' + $millisecs);
  });
}

function checkForSelections() {
  if(getselectedInputs()) { 
    $($addtocart_btn).removeAttr('disabled').html($($addtocart_btn).data('originalText'));
  } else { 
    $($addtocart_btn).attr('disabled','disabled').html($($addtocart_btn).data('disabledText'));
  }
}

function bundle_rerenderCart() {

}



$(document).ready(function() {
    if (window.location.href.indexOf("theskimmbsd") > -1) {
      $(location).prop('href', 'https://www.irisandromeo.com/products/power-peptide-lip-balm-peach-fuchsia')
    }
});
